export const reportTypes = [
  {
    id: 'quick',
    title: 'Quick Summary',
    duration: '2 min read',
    description: 'Perfect for a high-level overview of Gold IRA benefits and top 3 provider rankings.',
    includes: ['Top 3 Rankings', 'Basic Fee Chart', 'Quick Start Checklist'],
    premium: false
  },
  {
    id: 'standard',
    title: 'Standard Report',
    duration: '10 min read',
    description: 'Our most popular choice. Detailed breakdown of the rollover process and tax implications.',
    includes: ['Full Provider Comparison', 'IRS Compliance Guide', 'Rollover Timeline'],
    premium: false
  },
  {
    id: 'detailed',
    title: 'Detailed Report',
    duration: '25 min read',
    description: 'Comprehensive analysis including historical performance data and storage security audits.',
    includes: ['Storage Depository Reviews', 'Asset Allocation Models', 'Custodian Fee Analysis'],
    premium: true
  },
  {
    id: 'deep-dive',
    title: 'Deep-Dive Report',
    duration: '45 min read',
    description: 'For serious investors. Includes macro-economic outlooks and advanced tax-straddle strategies.',
    includes: ['Economic Analyst Insights', 'Legacy Planning Tips', 'Advanced Hedging Tactics'],
    premium: true
  },
  {
    id: 'exec-summary',
    title: 'Executive Summary Only',
    duration: '5 min read',
    description: 'Consolidated data points and final verdicts for busy professionals and decision makers.',
    includes: ['Key Performance Indicators', 'Final Recommendation', 'Actionable Steps'],
    premium: true
  },
  {
    id: 'client-ready',
    title: 'Client-Ready Full Report',
    duration: '60+ min read',
    description: 'A professional-grade dossier suitable for review with your CPA or Financial Advisor.',
    includes: ['Audit-Ready Documentation', 'Full Market Disclosure', 'Advisor Discussion Guide'],
    premium: true
  }
];